import type { SDKConfig } from '../types/events'

export class Config {
  private static instance: Config
  private config: Required<SDKConfig>

  private constructor() {
    // Default configuration
    this.config = {
      apiKey: '',
      endpoint: 'https://api.radar-snap.com/v1/events/batch',
      batchSize: 50,
      flushInterval: 10000, // 10 seconds
      debug: false,
      capturePageViews: true,
      captureClicks: true,
      capturePerformance: true,
      captureErrors: true
    }
  }

  public static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config()
    }
    return Config.instance
  }

  public initialize(userConfig: SDKConfig): void {
    if (!userConfig.apiKey) {
      throw new Error('RadarSnap SDK: API key is required')
    }

    this.config = {
      ...this.config,
      ...userConfig
    }

    if (this.config.debug) {
      console.log('[RadarSnap] Initialized with config:', this.config)
    }
  }

  public get<K extends keyof Required<SDKConfig>>(key: K): Required<SDKConfig>[K] {
    return this.config[key]
  }

  public getAll(): Required<SDKConfig> {
    return { ...this.config }
  }

  public isDebug(): boolean {
    return this.config.debug
  }
}

export default Config.getInstance()